import { render } from "./priceList.vue?vue&type=template&id=5dd09dbd&scoped=true"
const script = {}

import "./priceList.vue?vue&type=style&index=0&id=5dd09dbd&scoped=true&lang=css"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd09dbd"]])

export default __exports__